import initialState from './initialState';
import {
  CLEAR_ROSTER_UPLOAD,
  UPLOAD_ROSTER,
  UPLOAD_ROSTER_DONE,
  UPLOAD_ROSTER_ERROR,
  UPLOAD_ROSTER_LOADING,
  UPLOAD_ROSTER_SUCCESS
} from '../actions/actionTypes';

const reducerUploadRoster = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_ROSTER_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        roster: null
      };
    case UPLOAD_ROSTER_SUCCESS:
      return {
        ...state,
        error: null,
        roster: action.roster
      };
    case UPLOAD_ROSTER_ERROR:
      return {
        ...state,
        error: action.error,
        roster: null
      };
    case UPLOAD_ROSTER_DONE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

const reducerClearRoster = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ROSTER_UPLOAD:
      return {
        ...state,
        loading: null,
        error: null,
        roster: null
      };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  if (action.type.startsWith(UPLOAD_ROSTER)) {
    return reducerUploadRoster(state, action);
  } else if (action.type.startsWith(CLEAR_ROSTER_UPLOAD)) {
    return reducerClearRoster(state, action);
  } else {
    return state;
  }
};
